import { Component, type ErrorInfo, type ReactNode } from 'react';

export class ErrorBoundary extends Component<
  { children: ReactNode; onReset?: () => void },
  { err: string | null }
> {
  state = { err: null as string | null };

  static getDerivedStateFromError(error: Error) {
    return { err: error.message || 'Something snapped.' };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
  }

  render() {
    if (this.state.err) {
      return (
        <div className="crash">
          <h2>The cabinet flickered</h2>
          <p>{this.state.err}</p>
          <button
            type="button"
            onClick={() => {
              this.setState({ err: null });
              this.props.onReset?.();
            }}
          >
            Back to lobby
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
